export const LANGUAGE_SHOW_RESET = 'LANGUAGE_SHOW_RESET'
export const LANGUAGE_SHOW_SET_ERROR = 'LANGUAGE_SHOW_SET_ERROR'
export const LANGUAGE_SHOW_SET_RETRIEVED = 'LANGUAGE_SHOW_SET_RETRIEVED'
export const LANGUAGE_SHOW_TOGGLE_LOADING = 'LANGUAGE_SHOW_TOGGLE_LOADING'
